module.exports = __webpack_public_path__ + "img/home.24f10592.svg";